// extracted by mini-css-extract-plugin
export var active = "behandlung-module--active--t9P9K";
export var backdrop = "behandlung-module--backdrop--CXBMu";
export var content = "behandlung-module--content--mCP1X";
export var navigationTab = "behandlung-module--navigation-tab--ueEFs";
export var placeholder = "behandlung-module--placeholder--WDWpz";
export var right = "behandlung-module--right--DTH1i";
export var subtitle = "behandlung-module--subtitle--df+26";
export var tabContainer = "behandlung-module--tab-container--m1meK";
export var tabTriangle = "behandlung-module--tab-triangle--lg26S";
export var tabTriangleNextIndicator = "behandlung-module--tab-triangle-next-indicator--7efBO";
export var tabs = "behandlung-module--tabs--yX03o";
export var text = "behandlung-module--text--xwYLv";
export var title = "behandlung-module--title--jPnTC";
export var titleContainer = "behandlung-module--title-container--zD6Ma";
export var titleOrange = "behandlung-module--title-orange--a+9BL";